module.exports = __webpack_public_path__ + "assets/6be7aa48aa4ef1067bd132b05493c61e.mp3";